import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CleverTapHandler from "dashboard-utils/lib/utils/clevertap";
import { isTestMode } from "dashboard-utils";
import { sendCTEvent } from "../utils/clevertap";

const useCleverTapEventOnRouteChange = () => {
  const history = useHistory();
  const [initialLoad, setInitialLoad] = useState(true);
  useEffect(() => {
    try {
      const cleverTapId = isTestMode
        ? process.env.CLEVERTAP_TEST_ID
        : process.env.CLEVERTAP_ID;
      CleverTapHandler.initialize(cleverTapId);
    } catch (e) {
      console.error("error in initializing clevertap in sidemenu", e);
    }
    const handleRouteChange = (location, action) => {
      if (document?.referrer && initialLoad) {
        // Send the event on initial load
        sendCTEvent({ isInitialLoad: true });
        setInitialLoad(false); // Update state to indicate initial load is done
      } else {
        // Send the event on subsequent route changes
        sendCTEvent({ isInitialLoad: false });
      }
    };
    handleRouteChange(); // Trigger event on initial load
    //  const unlisten = history.listen(handleRouteChange);  // execute history
  }, [history.location.pathname, initialLoad]);
  return { initialLoad };
};
export default useCleverTapEventOnRouteChange;
